import { HeTimesheets } from "@/features"

const HeTimesheetsPage = () => {
  return <HeTimesheets />
}

export default HeTimesheetsPage
